import { render, staticRenderFns } from "./ChangeShiftDetail.vue?vue&type=template&id=a89c5db0&"
import script from "./ChangeShiftDetail.vue?vue&type=script&lang=js&"
export * from "./ChangeShiftDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChangeShiftDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports